import axios from "../axios-auth";
import orginal_axios from "axios";

export const damageService = {
    getDamageList,
    getAllDamageList,
    getDamageDetail,
    saveDamage,
    printDamageInvoice,
    showWindowDialog,
    exportAllDamageHeaderDetailExcel,
    getDamageSaleReportByCategoryGroup,
    getDamageSaleReportByCategoryGroupPrint,
    getAllDamageInvoiceType,
};

function getDamageList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.invoiceType) {
        params["invoiceType"] = searchParams.invoiceType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.saleTeamIds) {
        params["saleTeamIds"] = searchParams.saleTeamIds.join();
    }
    if (searchParams.creditNoteNo) {
        params["creditNoteNo"] = searchParams.creditNoteNo;
    }
    return axios.get("/auth/damages", { params });
}

function getAllDamageList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.invoiceType) {
        params["invoiceType"] = searchParams.invoiceType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.saleTeamIds) {
        params["saleTeamIds"] = searchParams.saleTeamIds.join();
    }

    return axios.get("/auth/damages", { params });
}

function getDamageDetail(id) {
    return axios.get("/auth/damage/" + id);
}

function saveDamage(damageHeader) {
    if (!damageHeader.id) {
        // new damageHeader
        return axios.post("/auth/damage", damageHeader);
    } else {
        // edit
        return axios.put("/auth/damage", damageHeader);
    }
}

function printDamageInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-damage-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function exportAllDamageHeaderDetailExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.customerCode) {
        params["customerCode"] = searchParams.customerCode;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.invoiceType) {
        params["invoiceType"] = searchParams.invoiceType;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.saleTeamIds) {
        params["saleTeamIds"] = searchParams.saleTeamIds.join();
    }
    if (searchParams.creditNoteNo) {
        params["creditNoteNo"] = searchParams.creditNoteNo;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/all-damage-header-detail-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

function getDamageSaleReportByCategoryGroup(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }
    return axios.get("/auth/damages-by-category-group", { params });
}

function getDamageSaleReportByCategoryGroupPrint(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }
    return axios.get("/auth/damages-by-category-group-print", { params });
}

function getAllDamageInvoiceType() {
    return axios.get("/auth/all-invoice-type");
}
